export class OtherClinicModel {
patientcode = '' ;
clinicdate = '' ;
cliniclocation = '' ;
clinicnotes = '' ;
docdepartment = '' ;
userid = '' ;
username = '' ;
clinictime = '' ;

}
